/**
 * @hidden
 */
export function invokeElementMethod(element, name) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    if (element && element.nativeElement) {
        return element.nativeElement[name].apply(element.nativeElement, args);
    }
}
var w = function () { return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1); };
/**
 * @hidden
 */
export var guid = function () { return "" + w() + w() + "-" + w() + "-" + w() + "-" + w() + "-" + w() + w() + w(); };



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-angular-inputs/dist/es/common/dom-utils.js
// module id = ../../../../@progress/kendo-angular-inputs/dist/es/common/dom-utils.js
// module chunks = 3